import { render, staticRenderFns } from "./quarter_mobile_card.vue?vue&type=template&id=2b3526ad&scoped=true&"
import script from "./quarter_mobile_card.vue?vue&type=script&lang=js&"
export * from "./quarter_mobile_card.vue?vue&type=script&lang=js&"
import style0 from "./quarter_mobile_card.vue?vue&type=style&index=0&id=2b3526ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3526ad",
  null
  
)

export default component.exports